import { useState } from 'react';
// @mui
import { TableRow, TableCell, MenuItem } from '@mui/material';
// components

import useLocales from 'src/hooks/useLocales';

import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import Iconify from 'src/components/Iconify';
import { TableMoreMenu } from 'src/components/table';
import { IBlock } from 'src/@types/Choqorak/Settings/Block';
// ----------------------------------------------------------------------

type Props = {
  row: IBlock;
  // selected: boolean;
  onEditRow: VoidFunction;
  //onSelectRow: VoidFunction;
  onDeleteRow: VoidFunction;
  handleDetail: VoidFunction;
  index: any;
};

export default function BlockTableRow({ row, onEditRow, onDeleteRow, handleDetail, index }: Props) {
  const { blockName, blockAddress } = row;
  const { translate } = useLocales();
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  return (
    <TableRow hover>
      <TableCell align="left">{index + 1}</TableCell>
      <TableCell align="left">{blockName}</TableCell>

      <TableCell align="left" sx={{ textTransform: 'capitalize' }}>
        {blockAddress}
      </TableCell>

      <TableCell align="left">
        <TableMoreMenu
          open={openMenu}
          onOpen={handleOpenMenu}
          onClose={handleCloseMenu}
          actions={
            <>
              <PermissionBasedGuard permissions={['Block-Delete']}>
                <MenuItem
                  onClick={() => {
                    onDeleteRow();
                    handleCloseMenu();
                  }}
                  sx={{ color: 'error.main' }}
                >
                  <Iconify icon={'eva:trash-2-outline'} />
                  {translate('CRUD.Delete')}
                </MenuItem>
              </PermissionBasedGuard>
              <PermissionBasedGuard permissions={['Block-Update']}>
                <MenuItem
                  onClick={() => {
                    onEditRow();
                    handleCloseMenu();
                  }}
                >
                  <Iconify sx={{ color: 'warning.main' }} icon={'eva:edit-fill'} />
                  {translate('CRUD.Update')}
                </MenuItem>
              </PermissionBasedGuard>
              <PermissionBasedGuard permissions={['Block-GetDetail']}>
                <MenuItem
                  onClick={() => {
                    handleDetail();
                    handleCloseMenu();
                  }}
                >
                  <Iconify sx={{ color: 'info.main' }} icon={'mdi:account-details'} />
                  {translate('CRUD.Detail')}
                </MenuItem>
              </PermissionBasedGuard>
            </>
          }
        />
      </TableCell>
    </TableRow>
  );
}
